import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

const useBlockPeriod = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const blockPeriod = async (requestData) => {
    setLoading(true);

    const requestBody = {
      startDate: requestData?.startDate,
      endDate: requestData?.endDate,
      startTime: requestData?.startTime,
      endTime: requestData?.endTime,
      // Whose calendar is blocked: there is no tenant-wide block (docs/MULTI_PROVIDER.md).
      providerId: requestData?.providerId,
    };

    try {
      const url = `/v1/tenants/${tenantId}/bookings/block-period`;
      await apiClient.post(url, requestBody);
      return true;
    } catch (error) {
      handleError(error, Routes.DASHBOARD);
    } finally {
      setLoading(false);
    }
  };

  return { blockPeriod, loading };
};

export default useBlockPeriod;
